import { IconFormNames, LifeArea, LocalizedLifeArea } from '@griply/types';

import { DocumentSnapshot } from '../types/firestore';
import { coerceRoadmapViewSettings } from './coerce-roadmap-view-settings';
import { firebaseObjectTimestampToDate } from './firebase-timestamp-to-date';

export const lifeAreaConverter = {
  fromFirestore: (snapshot: DocumentSnapshot): LifeArea | LocalizedLifeArea => {
    const data = firebaseObjectTimestampToDate(snapshot.data()) as Record<
      string,
      unknown
    >;
    return {
      ...data,
      name:
        typeof data.name === 'string'
          ? (data.name as string).trim()
          : data.name,
      iconName: Object.values(IconFormNames).includes(
        data.iconName as IconFormNames,
      )
        ? data.iconName
        : IconFormNames.PlaceholderIcon,
      visionPreview: data.visionPreview ?? null,
      roadmap: coerceRoadmapViewSettings(data.roadmap),
    } as LifeArea | LocalizedLifeArea;
  },
  toFirestore: (lifeArea: LifeArea | LocalizedLifeArea) => lifeArea,
};
